import apiClient from "../api/axios";
import { handleApiError } from "../api/handleApiError";
import type {
  GetEmissionFactorsParams,
  GetEmissionFactorsResponse,
  EmissionFactorDataV2,
} from "../models/EmissionFactors";
import { ResponseEmissionFactors } from "../models/dto/response/ResponseEmissionFactors";

const BASE = {
  v1: "/v1/emission-factors",
  v2: "/v2/emission-factors",
} as const;

const handleError = (error: unknown) =>
  handleApiError(
    error,
    {
      FORBIDDEN_ACCESS_ERROR: "Forbidden-Access-Error",
      EMISSION_FACTORS_RETRIEVAL_PROCESS_FAILED: "error-get-emission-factors",
      FORBIDDEN_ACTION_ERROR: "Forbidden-Access-Error",
    },
    "Forbidden-Access-Error",
  );

const emissionFactorService = {
  getEmissionFactors: async (group: string) => {
    try {
      const res = await apiClient.get(`${BASE.v1}/${group}`);
      return (res.data as ResponseEmissionFactors).results.emissionData;
    } catch (err) {
      handleError(err);
    }
  },

  getEmissionFactorsV2: async (
    params: GetEmissionFactorsParams,
  ): Promise<EmissionFactorDataV2[] | undefined> => {
    try {
      const res = await apiClient.get<GetEmissionFactorsResponse>(
        `${BASE.v2}/${params.group}`,
        {
          params: {
            startActivity: params.startActivity,
            endActivity: params.endActivity,
          },
        },
      );
      return res.data.results.emissionData;
    } catch (err) {
      handleError(err);
    }
  },
};

export default emissionFactorService;
